import React from 'react';
import { UseFormMethods, useWatch } from 'react-hook-form';
import { Link } from '@material-ui/core';
import WithFormContext from '../../../../hocs/WithFormContext/WithFormContext';
import Checkbox from '../../../Common/Checkbox/Checkbox';
import Tooltip from 'components/Common/Tooltip/Tooltip';

const FormCheckbox = WithFormContext(Checkbox);
interface OrderAutoRenewCheckboxProps {
    defaultSubscriptionPlanId?: string;
    userHasSubscriptionPlanAvailable?: boolean;
    formMethods?: UseFormMethods;
}

const OrderAutoRenewCheckbox = (props: OrderAutoRenewCheckboxProps): JSX.Element | null => {
    const subscriptionPlanId = useWatch({
        control: props.formMethods?.control,
        name: 'subscriptionPlanId',
        defaultValue: props.defaultSubscriptionPlanId,
    });
    const show = subscriptionPlanId === props.defaultSubscriptionPlanId;
    const tooltipText =
        'If you opt for autorenewal, you will not be able to enroll in the monthly installment program.  Each renewal cycle allows for only one payment program selection.';
    const label = (
        <>
            AIA Membership Autorenewal: I agree to enroll in AIA&#39;s Automatic Membership Dues Renewal Program. By
            selecting this option, I acknowledge and agree to the{' '}
            <Link
                href="https://www.aia.org/terms-conditions-membership-autorenewal#:~:text=Your%20auto%2Drenewal%20will%20process,on%20the%20next%20business%20day"
                target="_blank"
                rel="noopener noreferrer"
            >
                terms &amp; conditions
            </Link>{' '}
            of the program. {props.userHasSubscriptionPlanAvailable ? <Tooltip title={tooltipText} /> : null}
        </>
    );

    return show ? (
        <>
            <FormCheckbox data-testid="auto-renew-checkbox" id="auto-renew" name="autoRenew" label={label} />
        </>
    ) : null;
};

export default OrderAutoRenewCheckbox;
